import React from "react";
import Layout from "../../common/Layout";
import { Formik } from "formik";
import UserGroupForm from "./UserGroupForm";
import { useNavigate } from "react-router-dom";
import { validateUserGroup } from "../Validations";
import { useCreateUserGroup } from "../../hooks/useCreateUserGroup";

const UserGroupInsert = () => {
  const navigate = useNavigate();
  const createUserGroupMutation = useCreateUserGroup();

  return (
    <Layout name="User Groups">
      <div className="wizard-container">
        <div className="col-md-8 col-12 mr-auto ml-auto">
          <div
            className="card card-wizard active"
            data-color="rose"
            id="wizardProfile"
          >
            <Formik
              initialValues={{
                name: "",
                groupChallenges: [],
                isCareerPath: false,
                menu: {
                  isPscVisible: true,
                  isCareerVisible: true,
                  isRankingVisible: false
                }
              }}
              validate={validateUserGroup}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                createUserGroupMutation.mutate(
                  {
                    name: values.name,
                    groupChallenges: values.groupChallenges,
                    isCareerPath: values.isCareerPath === "true",
                    menu: values.menu 
                  },
                  {
                    onSuccess: () => {
                      navigate("/admin-settings/userGroups");
                    },
                    onError: error => {
                      console.log(error);
                    }
                  }
                );
              }}
            >
              {({ isSubmitting, values, handleChange, setFieldValue }) => (
                <UserGroupForm
                  isSubmitting={isSubmitting}
                  values={values}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                />
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UserGroupInsert;
